export const selectPermissionLoading = (state) => state.permission.loading;
export const selectUserRole = (state) => state.permission.role;
export const selectPermissions = (state) => state.permission.permissions;
export const selectAllowStatusesByStatus = (status) => (state) =>
  state.permission.permissions[status]?.next_statuses || [];
export const selectPermissionByStatus = (status) => (state) =>
  state.permission.permissions[status] ?? {};
